import { Container } from "@mui/material";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChannelFormSchema } from "@ses-mams/validation";
import { captureException } from "@sentry/react";
import {
  SelectAllMembersQuery,
  formatSelectAllMembersQuery,
} from "@ses-mams/react-utils";
import { useToast } from "~/components/ui/toast";
import { tsr } from "~/utils/client";
import { EditChannelForm } from "./components/EditChannelForm";

export const EditChannelMembersPage = () => {
  const channelId = useParams().channelId as string;

  const navigate = useNavigate();

  const { mutateAsync, isPending } = tsr.chat.addChannelMembers.useMutation();

  const { addToast } = useToast();

  const onSubmit = useCallback(
    async (
      data: ChannelFormSchema,
      selectAllMembersQuery?: SelectAllMembersQuery
    ) => {
      try {
        await mutateAsync({
          params: {
            channelId,
          },
          body: {
            memberIds: data.members.map(m => m.id),
            groupIds: data.groups.map(g => g.id),
            contactGroupIds: data.contactGroups.map(cg => cg.id),
            selectAllMembersQuery: formatSelectAllMembersQuery(
              selectAllMembersQuery
            ),
          },
        });

        navigate("/messages");
      } catch (error) {
        captureException(error);

        addToast({
          tone: "critical",
          title: "Sorry, something went wrong",
          message: "Please try again",
        });
      }
    },
    []
  );

  return (
    <Container maxWidth="sm">
      <EditChannelForm
        onSubmit={onSubmit}
        busy={isPending}
        // We don't persist any name changes on this page, so use the id as the name to satisfy form validation.
        initialChannel={{ name: channelId }}
      />
    </Container>
  );
};
